{
  "close": "Kapat",
  "notifications": "{count, plural, one {# bildirim} other {# bildirim}}."
}
